import React, { useEffect, useState } from "react";
import PageLayout from "../../PageLayout/PageLayout";
import classes from "./Faq.module.css";
import Fonts from "../../../../../stories/assets/Fonts";
import { AddIconBlue, addicongray } from "../../../../../constant/imagePath";
import Colors from "../../../../../stories/assets/Colors";
import { Container, Row, Col } from "react-bootstrap";
import { DropDown } from "../../../../../stories/DropDown/DropDown";
import { TextArea } from "../../../../../stories/TextArea/TextArea";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { CommonQuestions } from "../../../../../stories/CommonQuestions/CommonQuestions";
import { Button } from "../../../../../stories/Button/Button";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";
import FaqMobile from "./FaqMobile";
import { useDispatch, useSelector } from "react-redux";
import { setPersonalData } from "../../../../../store/Actions/authAction";

const FaqDesktop = () => {
  const getDataFromRedux = useSelector((state) => state.onBoardingReducer?.faq);
  const dispatch = useDispatch();

  const [question, setQuestion] = useState(null);
  const [answer, setAnswer] = useState("");
  const [editingId, setEdititngId] = useState();
  const [isEditing, setIsEditing] = useState(false);

  const [faq, setFaq] = useState(getDataFromRedux ? getDataFromRedux : []);

  const handleDelete = (item) => {
    const newFaqData = faq?.slice();
    const index = newFaqData.findIndex((data) => data?._id === item?._id);
    newFaqData?.splice(index, 1);
    setFaq(newFaqData);
  };
  const handleEdit = (item) => {
    setEdititngId(item?._id);
    setIsEditing(true);
    faq.find((data) => {
      console.log({ data });
      if (data?._id === item?._id) {
        setQuestion({ label: data?.question, value: data?.question });
        setAnswer(data?.answer);
      }
    });
  };

  const handleAddMore = () => {
    if (isEditing) {
      const newFaqData = faq?.slice();
      const index = newFaqData.findIndex((data) => data?._id === editingId);
      newFaqData?.splice(index, 1, {
        question: question?.label,
        answer: answer,
        _id: newFaqData[index]?.id,
      });
      setFaq(newFaqData);
      setIsEditing(false);
    } else {
      if (answer.length > 0 && question?.label?.length > 0) {
        setFaq([
          ...faq,
          {
            question: question?.label,
            answer: answer,
            _id: Math.floor(Math.random() * 1000),
          },
        ]);
      }
    }
    setQuestion(null);
    setAnswer("");
  };
  function saveDataIntoRedux() {
    dispatch(setPersonalData("faq", faq));
  }

  return (
    <div className={[classes.FaqScreen].join(" ")}>
      <Container fluid className={[classes.container, "p-0"].join(" ")}>
        <Row className={[classes.mb52, "g-0"].join(" ")}>
          <Col md={12}>
            <div className={`${classes.edit_heading_main_div}`}>
              <div>
                <h3
                  style={{
                    ...Fonts.h3,
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  Edit Profile
                </h3>
              </div>
              <div className={`${classes.edit_heading_button_div}`}>
                <Button
                  primary={false}
                  size="Medium"
                  customStyle={{
                    padding: "14px 24px",
                    width: "max-content",
                    marginRight: "12px",
                    ...Fonts.b2,
                  }}
                >
                  Profile preview
                </Button>
                <Button
                  primary={true}
                  size="Medium"
                  customStyle={{
                    padding: "14px 24px",
                    width: "max-content",
                    ...Fonts.b2,
                  }}
                  onClick={saveDataIntoRedux}
                >
                  Save changes
                </Button>
              </div>
            </div>
          </Col>
        </Row>
        <Row className={[classes.row, "g-0"].join(" ")}>
          {faq?.length > 0 && (
            <Col md={12} className={[classes.pb32].join(" ")}>
              <CommonQuestions
                data={faq?.map((item) => ({
                  _id: item?._id,
                  title: item?.question,
                  description: item?.answer,
                }))}
                btnsPosition="Top"
                handleDelete={handleDelete}
                handleEdit={handleEdit}
                headingStyle={{ ...Fonts.p1, fontFamily: "inter-600" }}
                descriptionClass={classes.descClass}
              />
            </Col>
          )}

          <Col md={12} className={[classes.mb32].join(" ")}>
            <DropDown
              options={[
                {
                  label: "Are there any other fees?",
                  value: "Are there any other fees? ",
                },
              ]}
              state={question}
              setter={setQuestion}
              label="Question"
              placeholder="Select Question"
            />
          </Col>
          <Col md={12} className={[classes.mb32].join(" ")}>
            <TextArea
              label="Answer"
              state={answer}
              setter={setAnswer}
              placeholder=""
            />
          </Col>
          <Col md={12} className={`${classes.mb80}`}>
            <LinkButtonWithIcon
              customStyle={{
                ...Fonts.b2,
                fontSize: "14px",
                lineHeight: "20px",
              }}
              primary={true}
              text="Add more"
              onClick={handleAddMore}
              leftIcon={AddIconBlue}
              disabled={((answer == "" || question == null) && true) || false}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
const Faq = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <FaqMobile /> : <FaqDesktop />;
};
export default Faq;
